var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedTruker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    fill: "#FEF2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    stroke: "#FECACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 9.08325H14.5301C14.6727 9.08325 14.7441 9.08325 14.8112 9.09937C14.8708 9.11366 14.9276 9.13723 14.9798 9.16921C15.0387 9.20529 15.0892 9.25573 15.19 9.35662L17.56 11.7266C17.6608 11.8274 17.7113 11.8779 17.7474 11.9367C17.7794 11.989 17.8029 12.0458 17.8172 12.1054C17.8333 12.1725 17.8333 12.2439 17.8333 12.3865V14.0416C17.8333 14.3134 17.8333 14.4493 17.7889 14.5565C17.7297 14.6994 17.6162 14.813 17.4732 14.8722C17.366 14.9166 17.2301 14.9166 16.9583 14.9166M14.0417 14.9166H13.1667M13.1667 14.9166V9.19992C13.1667 8.54653 13.1667 8.21983 13.0395 7.97026C12.9277 7.75074 12.7492 7.57226 12.5297 7.46041C12.2801 7.33325 11.9534 7.33325 11.3 7.33325H8.03333C7.37994 7.33325 7.05324 7.33325 6.80368 7.46041C6.58415 7.57226 6.40568 7.75074 6.29383 7.97026C6.16667 8.21983 6.16667 8.54653 6.16667 9.19992V13.7499C6.16667 14.3943 6.689 14.9166 7.33333 14.9166M13.1667 14.9166H10.8333M7.33333 14.9166C7.33333 15.8831 8.11684 16.6666 9.08333 16.6666C10.0498 16.6666 10.8333 15.8831 10.8333 14.9166M7.33333 14.9166C7.33333 13.9501 8.11684 13.1666 9.08333 13.1666C10.0498 13.1666 10.8333 13.9501 10.8333 14.9166M16.9583 15.2083C16.9583 16.0137 16.3054 16.6666 15.5 16.6666C14.6946 16.6666 14.0417 16.0137 14.0417 15.2083C14.0417 14.4028 14.6946 13.7499 15.5 13.7499C16.3054 13.7499 16.9583 14.4028 16.9583 15.2083Z",
    stroke: "#DC2626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTruker);
export default __webpack_public_path__ + "static/media/red_truker.67f2df04922486aa490d1e964c12ff60.svg";
export { ForwardRef as ReactComponent };